module.exports = __webpack_public_path__ + "img/banner7.f187995a.jpg";